/* eslint-disable */
import React, { useState } from "react";
import { parsePytestLog } from "../utils/pytestLogParser";

export default function PytestLogInspector({ rawLog, runTitle, parsedSteps = [] }) {
  const [viewMode, setViewMode] = useState("series"); // "series" | "error" | "raw"
  const [expandedStep, setExpandedStep] = useState(null);

  const parsed = parsePytestLog(rawLog, parsedSteps);
  const { summary, failures, stepSeries } = parsed;

  const toggleExpand = (idx) => {
    setExpandedStep(expandedStep === idx ? null : idx);
  };

  return (
    <div style={{ backgroundColor: "#ffffff", borderRadius: "12px", border: "1px solid #cbd5e1", overflow: "hidden", boxShadow: "0 4px 12px rgba(0,0,0,0.04)", textAlign: "left" }}>
      {/* Inspector Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "#f8fafc", padding: "14px 20px", borderBottom: "1px solid #e2e8f0", flexWrap: "wrap", gap: "12px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <span style={{ fontSize: "20px" }}></span>
          <div>
            <h4 style={{ margin: 0, fontSize: "15px", fontWeight: "800", color: "#0f172a" }}>
              Execution Log — Numbered Code Step Series
            </h4>
            <span style={{ fontSize: "12px", color: "#64748b" }}>
              {runTitle || "Sequential Step Execution & Code Line Telemetry"}
            </span>
          </div>
        </div>

        {/* View Mode Toggle Buttons */}
        <div style={{ display: "flex", backgroundColor: "#e2e8f0", padding: "3px", borderRadius: "8px", gap: "2px" }}>
          <button
            type="button"
            onClick={() => setViewMode("series")}
            style={{
              padding: "6px 14px",
              fontSize: "12px",
              fontWeight: "700",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              backgroundColor: viewMode === "series" ? "#ffffff" : "transparent",
              color: viewMode === "series" ? "#FD6101" : "#475569",
              boxShadow: viewMode === "series" ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
              transition: "all 0.2s ease"
            }}
          >
            🔢 Code Step Series ({stepSeries.length})
          </button>

          <button
            type="button"
            onClick={() => setViewMode("error")}
            style={{
              padding: "6px 14px",
              fontSize: "12px",
              fontWeight: "700",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              backgroundColor: viewMode === "error" ? "#ffffff" : "transparent",
              color: viewMode === "error" ? "#FD6101" : "#475569",
              boxShadow: viewMode === "error" ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
              transition: "all 0.2s ease"
            }}
          >
            ! Failure & Fix Details ({failures.length})
          </button>

          <button
            type="button"
            onClick={() => setViewMode("raw")}
            style={{
              padding: "6px 14px",
              fontSize: "12px",
              fontWeight: "700",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              backgroundColor: viewMode === "raw" ? "#ffffff" : "transparent",
              color: viewMode === "raw" ? "#FD6101" : "#475569",
              boxShadow: viewMode === "raw" ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
              transition: "all 0.2s ease"
            }}
          >
            📄 Raw Terminal Console
          </button>
        </div>
      </div>

      {/* VIEW 1: NUMBERED CODE STEP SERIES FLOW */}
      {viewMode === "series" ? (
        <div style={{ padding: "20px", display: "flex", flexDirection: "column", gap: "16px" }}>
          {/* Summary Metric Cards */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))", gap: "12px" }}>
            <div style={{ backgroundColor: "#f8fafc", padding: "10px 14px", borderRadius: "8px", border: "1px solid #e2e8f0" }}>
              <span style={{ fontSize: "10.5px", fontWeight: "700", color: "#64748b", textTransform: "uppercase" }}>Total Code Steps</span>
              <div style={{ fontSize: "17px", fontWeight: "800", color: "#0f172a" }}>{stepSeries.length}</div>
            </div>

            <div style={{ backgroundColor: "#f0fdf4", padding: "10px 14px", borderRadius: "8px", border: "1px solid #bbf7d0" }}>
              <span style={{ fontSize: "10.5px", fontWeight: "700", color: "#166534", textTransform: "uppercase" }}>Passed Steps</span>
              <div style={{ fontSize: "17px", fontWeight: "800", color: "#16a34a" }}>
                {stepSeries.filter(s => s.status === "PASSED").length}
              </div>
            </div>

            <div style={{ backgroundColor: stepSeries.some(s => s.status === "FAILED") ? "#fef2f2" : "#f8fafc", padding: "10px 14px", borderRadius: "8px", border: stepSeries.some(s => s.status === "FAILED") ? "1px solid #fecdd3" : "1px solid #e2e8f0" }}>
              <span style={{ fontSize: "10.5px", fontWeight: "700", color: stepSeries.some(s => s.status === "FAILED") ? "#991b1b" : "#64748b", textTransform: "uppercase" }}>Failed Steps</span>
              <div style={{ fontSize: "17px", fontWeight: "800", color: stepSeries.some(s => s.status === "FAILED") ? "#dc2626" : "#64748b" }}>
                {stepSeries.filter(s => s.status === "FAILED").length}
              </div>
            </div>

            <div style={{ backgroundColor: "#f8fafc", padding: "10px 14px", borderRadius: "8px", border: "1px solid #e2e8f0" }}>
              <span style={{ fontSize: "10.5px", fontWeight: "700", color: "#64748b", textTransform: "uppercase" }}>Total Time</span>
              <div style={{ fontSize: "17px", fontWeight: "800", color: "#FD6101" }}>{summary.duration || "4.2s"}</div>
            </div>
          </div>

          {/* Numbered Code Step Series Cards */}
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <h5 style={{ margin: "4px 0 0 0", fontSize: "13px", fontWeight: "800", color: "#0f172a", textTransform: "uppercase", letterSpacing: "0.5px" }}>
               Numbered Step Series & Executed Code Lines
            </h5>

            {stepSeries.map((step, idx) => {
              const isFail = step.status === "FAILED";
              const isExpanded = expandedStep === idx || isFail;

              return (
                <div
                  key={idx}
                  style={{
                    borderRadius: "10px",
                    border: isFail ? "1.5px solid #fca5a5" : "1px solid #e2e8f0",
                    backgroundColor: isFail ? "#fff5f5" : "#ffffff",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                    overflow: "hidden",
                    transition: "all 0.2s ease"
                  }}
                >
                  {/* Step Header */}
                  <div
                    onClick={() => toggleExpand(idx)}
                    style={{
                      display: "flex",
                      justify: "space-between",
                      alignItems: "center",
                      padding: "12px 16px",
                      cursor: "pointer",
                      backgroundColor: isFail ? "#fee2e2" : "#f8fafc",
                      borderBottom: "1px solid #cbd5e1"
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
                      {/* Step Number Circle */}
                      <div
                        style={{
                          width: "28px",
                          height: "28px",
                          borderRadius: "50%",
                          backgroundColor: isFail ? "#dc2626" : "#FD6101",
                          color: "#ffffff",
                          fontWeight: "800",
                          fontSize: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                        }}
                      >
                        {step.stepNumber}
                      </div>

                      <div>
                        <div style={{ fontSize: "11px", fontWeight: "800", color: isFail ? "#991b1b" : "#475569", textTransform: "uppercase" }}>
                          Step {step.stepNumber} — {step.action} {step.lineNumber ? `(Line ${step.lineNumber})` : ""}
                        </div>
                        <div style={{ fontSize: "13.5px", fontWeight: "700", color: isFail ? "#7f1d1d" : "#0f172a", marginTop: "2px" }}>
                          {step.title}
                        </div>
                      </div>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <span
                        style={{
                          fontSize: "11px",
                          fontWeight: "800",
                          padding: "3px 10px",
                          borderRadius: "12px",
                          backgroundColor: isFail ? "#ef4444" : "#10b981",
                          color: "#ffffff",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px"
                        }}
                      >
                        {isFail ? "✗ FAILED" : "✓ PASSED"}
                      </span>

                      <span style={{ fontSize: "11.5px", color: "#64748b", fontWeight: "600" }}>
                         {step.duration || "0.4s"}
                      </span>

                      <span style={{ fontSize: "12px", color: "#64748b" }}>
                        {isExpanded ? "▲" : "▼"}
                      </span>
                    </div>
                  </div>

                  {/* Body: Prominent Code Executed Block */}
                  <div style={{ padding: "14px 16px", backgroundColor: isFail ? "#fff1f2" : "#ffffff", fontSize: "12.5px" }}>
                    <div style={{ marginBottom: "10px" }}>
                      <span style={{ fontSize: "11px", fontWeight: "800", color: "#475569", textTransform: "uppercase", display: "flex", alignItems: "center", gap: "6px" }}>
                         Code Executed:
                      </span>
                      <pre
                        style={{
                          margin: "6px 0 0 0",
                          padding: "10px 14px",
                          backgroundColor: "#0f172a",
                          color: isFail ? "#fca5a5" : "#38bdf8",
                          borderRadius: "8px",
                          fontFamily: "monospace",
                          fontSize: "12px",
                          lineHeight: "1.5",
                          borderLeft: isFail ? "4px solid #ef4444" : "4px solid #3b82f6",
                          overflowX: "auto"
                        }}
                      >
                        {step.codeExecuted || `# Step ${step.stepNumber} execution`}
                      </pre>
                    </div>

                    {isExpanded && (
                      <div style={{ color: isFail ? "#991b1b" : "#475569", fontWeight: "600", marginTop: "8px" }}>
                        <span style={{ fontSize: "11px", textTransform: "uppercase", color: "#64748b", display: "block" }}>Telemetry Log Output:</span>
                        <div style={{ backgroundColor: "#f8fafc", border: "1px solid #e2e8f0", padding: "8px 12px", borderRadius: "6px", marginTop: "4px", fontSize: "12px" }}>
                          {step.details}
                        </div>
                      </div>
                    )}

                    {isFail && failures.length > 0 && (
                      <div style={{ marginTop: "10px", backgroundColor: "#ffffff", padding: "12px", borderRadius: "8px", border: "1px solid #fca5a5" }}>
                        <div style={{ fontSize: "11px", fontWeight: "800", color: "#991b1b", textTransform: "uppercase" }}> Failure Cause & AI Recommended Fix</div>
                        <div style={{ fontSize: "12.5px", color: "#7f1d1d", fontWeight: "700", marginTop: "4px" }}>
                          {failures[0].humanSummary}
                        </div>
                        <div style={{ fontSize: "12px", color: "#047857", fontWeight: "600", marginTop: "4px" }}>
                           Suggested Fix: {failures[0].suggestedFix}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : viewMode === "error" ? (
        /* VIEW 2: FAILURE & FIX DETAILS */
        <div style={{ padding: "20px", display: "flex", flexDirection: "column", gap: "16px" }}>
          {failures.length > 0 ? (
            failures.map((item, idx) => (
              <div key={idx} style={{ border: "1.5px solid #fca5a5", borderRadius: "10px", backgroundColor: "#ffffff", overflow: "hidden" }}>
                <div style={{ backgroundColor: "#fee2e2", padding: "12px 16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <span style={{ fontSize: "16px" }}>✗</span>
                    <strong style={{ fontSize: "14px", color: "#991b1b" }}>{item.testName}</strong>
                    <span style={{ fontSize: "11.5px", backgroundColor: "#ffffff", color: "#7f1d1d", padding: "2px 8px", borderRadius: "4px", border: "1px solid #fca5a5", fontFamily: "monospace" }}>
                      📄 {item.filePath}:{item.lineNo}
                    </span>
                  </div>
                  <span style={{ fontSize: "11px", fontWeight: "800", backgroundColor: "#eff6ff", color: "#FD6101", padding: "3px 10px", borderRadius: "12px", border: "1px solid #bfdbfe" }}>
                     {item.mappedRule}
                  </span>
                </div>

                <div style={{ padding: "16px", display: "flex", flexDirection: "column", gap: "12px" }}>
                  <div style={{ backgroundColor: "#fff1f2", borderLeft: "4px solid #ef4444", padding: "12px", borderRadius: "0 8px 8px 0" }}>
                    <div style={{ fontSize: "11px", fontWeight: "800", color: "#991b1b", textTransform: "uppercase" }}>Root Cause Explanation</div>
                    <div style={{ fontSize: "13.5px", fontWeight: "700", color: "#7f1d1d", marginTop: "4px" }}>
                      {item.humanSummary}
                    </div>
                  </div>

                  <div style={{ backgroundColor: "#f0fdf4", borderLeft: "4px solid #10b981", padding: "12px", borderRadius: "0 8px 8px 0" }}>
                    <div style={{ fontSize: "11px", fontWeight: "800", color: "#065f46", textTransform: "uppercase" }}> How to Fix</div>
                    <div style={{ fontSize: "13px", fontWeight: "600", color: "#047857", marginTop: "4px" }}>
                      {item.suggestedFix}
                    </div>
                  </div>

                  <pre style={{ margin: 0, padding: "12px", backgroundColor: "#0f172a", color: "#38bdf8", borderRadius: "8px", fontFamily: "monospace", fontSize: "12px", lineHeight: "1.5", overflowX: "auto" }}>
                    {item.tracebackLines && item.tracebackLines.length > 0 ? item.tracebackLines.join("\n") : item.rawBlock}
                  </pre>
                </div>
              </div>
            ))
          ) : (
            <div style={{ backgroundColor: "#f0fdf4", border: "1px solid #bbf7d0", padding: "24px", borderRadius: "10px", textAlign: "center", color: "#166534" }}>
              <span style={{ fontSize: "28px" }}>🎉</span>
              <h4 style={{ margin: "8px 0 0 0", fontSize: "16px", fontWeight: "800" }}>No Execution Failures Detected!</h4>
              <p style={{ margin: "4px 0 0 0", fontSize: "13px" }}>All code steps completed with 100% success rate.</p>
            </div>
          )}
        </div>
      ) : (
        /* VIEW 3: RAW CONSOLE TERMINAL */
        <div style={{ padding: "16px", backgroundColor: "#0f172a" }}>
          <pre style={{ margin: 0, color: "#38bdf8", fontFamily: "monospace", fontSize: "12px", lineHeight: "1.6", whiteSpace: "pre-wrap", overflowX: "auto", textAlign: "left" }}>
            {rawLog || "No raw console output log captured."}
          </pre>
        </div>
      )}
    </div>
  );
}
